<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">{{ title }}</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'home', params: { locale } }">{{
                  $t("Inicio")
                }}</router-link>
              </li>
              <li
                v-for="(item, index) in breadcrumb"
                :key="index"
                class="breadcrumb-item"
              >
                {{ item }}
              </li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <router-view />
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>
import { mapState } from "vuex";

//const upper = (lower) => lower.replace(/^\w/, (c) => c.toUpperCase());

export default {
  computed: {
    ...mapState(["year", "title"]),
    breadcrumb() {
      const breadcrumb = [];
      breadcrumb.push(this.$i18n.t(this.$route.meta.breadcrumb));

      if (this.$route.params.year) breadcrumb.push(this.$route.params.year);

      return breadcrumb;
    },
  },
};
</script>

<style></style>

<i18n>
{
  "es": {
    "Inicio" : "Inicio",
    "Resoluciones" : "Resoluciones",
    "Integrantes" : "Integrantes",
    "Lenguaje Claro" : "Lenguaje Claro",
    "Manual de Procedimientos" : "Manual de Procedimientos",
    "Planificación" : "Planificación",
    "Contacto" : "Contacto",
    "Ubicacion" : "Ubicacion"
  },
  "en": {
    "Inicio" : "Home",
    "Resoluciones" : "Rulings Issued",
    "Integrantes" : "Team",
    "Lenguaje Claro" : "Plain Language and Style Guide",
    "Manual de Procedimientos" : "Procedure & Management Manual",
    "Planificación" : "Objectives and Planning Guide",
    "Contacto" : "Contact",
    "Ubicacion" : "Location"
  }
}
</i18n>
